import ga4, { GA4 } from './ga4'

export const ReactGAImplementation = GA4

export default ga4
